import React, { useState } from 'react';
import { ChevronDown, ChevronRight } from 'lucide-react';

/**
 * Collapsible section wrapper for organizing migrated components
 */
const CollapsibleSection = ({ 
  title, 
  icon, 
  description, 
  children, 
  defaultOpen = false,
  className = '' 
}) => {
  const [isOpen, setIsOpen] = useState(defaultOpen);

  return (
    <div className={`landing-collapsible-section ${className}`}>
      <button
        className="landing-collapsible-header"
        onClick={() => setIsOpen(!isOpen)}
        type="button"
        aria-expanded={isOpen}
      >
        <div className="landing-collapsible-header-content">
          {icon && <span className="landing-collapsible-icon">{icon}</span>}
          <div className="landing-collapsible-title-group">
            <h5 className="landing-collapsible-title">{title}</h5>
            {description && (
              <p className="landing-collapsible-description">{description}</p>
            )}
          </div>
        </div>
        {isOpen ? (
          <ChevronDown size={20} className="landing-collapsible-chevron" />
        ) : (
          <ChevronRight size={20} className="landing-collapsible-chevron" />
        )}
      </button>
      {isOpen && (
        <div className="landing-collapsible-content">
          {children}
        </div>
      )}
    </div>
  );
};

export default CollapsibleSection;




